"use strict";

export default {
  apiUrl: ""
};



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-fleetlink/fleetlink.config.js